




















































































import mapboxgl from 'mapbox-gl'
import { Component, InjectReactive, Vue, Watch } from 'vue-property-decorator'
import RestClient from "../components/RestClient.vue"
import Settings from "../settings"
import Account from "../account"

@Component
export default class VueComponent extends Vue {
    $log: any
    @InjectReactive() settings!: Settings
    @InjectReactive() restClient!: RestClient
    @InjectReactive() account?: Account
    pending!: boolean
    map?: any
    center: any
    latitude?: number
    longitude?: number
    elevation?: string
    data() {
        return {
            pending: false,
            map: null,
            center: null,
            latitude: null,
            longitude: null,
            elevation: null,
        }
    }
    mounted() {
        this.reset()
        this.initMap()
    }
    @Watch('settings')
    @Watch('account')
    initMap() {
        if (this.account) {
            setTimeout(() => {
                if (!this.map && this.settings && this.account) {
                    mapboxgl.accessToken = this.settings.mapbox_access_token
                    var map = new mapboxgl.Map({
                        container: "map",
                        style: "mapbox://styles/mapbox/outdoors-v11",
                        center: this.center, // starting position [lng, lat]
                        zoom: 15, // starting zoom
                    })
                    map.addControl(new mapboxgl.NavigationControl())
                    var center = new mapboxgl.Marker()
                    center.setLngLat(map.getCenter()).addTo(map)
                    map.on("move", () => {
                        this.center = map.getCenter()
                        center.setLngLat(this.center)
                    })
                    map.on("load", this.refresh)
                    map.on("moveend", this.refresh)
                    this.map = map
                    this.center = map.getCenter()
                }
            }, 0)
        } else {
            this.reset()
        }
    }
    @Watch('center')
    onCenter(val: any) {
        this.latitude = val.lat
        this.longitude = val.lng
    }
    reset() {
        this.center = {lng: 120.957283, lat: 23.47}
        this.elevation = undefined
    }
    refresh() {
        if (!$('#map').is(":visible")) {
            return
        }
        if (!this.account || this.pending) {
            return
        }
        var c = this.map.getCenter();
        this.restClient.request('POST', '/api/v1/elevations', [[c.lng, c.lat]], (data) => {
            this.pending = false
            var elevation = data[0]
            if (elevation) {
                this.elevation = (Math.round(elevation * 100) / 100).toFixed(2)
            } else {
                this.elevation = undefined
            }
        }, (): boolean => {
            this.pending = false
            return false
        })
        this.pending = true
    }
    submit() {
        this.map.jumpTo({center: {lng: this.longitude, lat: this.latitude}})
    }
}
